<template>

    <ion-content class="block__login">
      <section class="block__login-wrapper d-flex justify-content-center align-items-center">
        <b-overlay 
          :show="show"
          rounded="sm"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small        
        >
          <b-card class="text-center" style="cursor:default;">
            <b-img :src="content.src" class="logo" fluid alt="logo" style="height: 40px; margin-bottom: 20px"></b-img>
            <p class="title">{{content.title}}</p>
            <form @submit.prevent="submit()">
              <div class="text-left" v-if="!konamiCode">

                <b-form  @submit.stop.prevent>
                  <label for="feedback-user">{{content.id}}</label>
                  <b-input type="email" v-model="userId" id="feedback-user" :class="{error:emailError}"></b-input>
                </b-form>


                <b-form @submit.stop.prevent>
                  <label for="text-password">{{content.password}}</label>
                  <b-input type="password" id="text-password" v-model="userPass" aria-describedby="password-help-block"></b-input>
                </b-form>
              </div>

              <div class="d-flex flex-column justify-content-center align-items-center flex-nowrap">
                <b-button  v-if="!konamiCode" v-on:click="tryLogin()" class="bt bt__connected" :disabled="notActivated" >{{content.bt_connection}}</b-button>
                <!--<b-button v-on:click="renewLogin()" class="bt bt__forget">{{content.bt_forget}}</b-button>-->
                <b-button v-if="ssoUri" v-on:click="ssoConnect()" class="bt bt__microsoft">
                  <img src="/img/microsoftLogo.svg" height="24px" width="24px">
                  Se connecter avec Microsoft
                </b-button>
              </div>

            </form>
          </b-card>
        </b-overlay>
      </section>


      <transition>
        <router-view></router-view>
      </transition>

      

        <b-toast id="error-message" solid toaster="b-toaster-top-full" auto-hide-delay="8000" variant="danger">
          <template v-slot:toast-title>
            <strong class="mr-auto">{{content.error}}</strong>
          </template>
          {{error_desc}}
        </b-toast>

    </ion-content>


</template>


<script>
import ApiAuthenticationService from "../../services/ApiAuthenticationService";
import PushNotificationService from "../../services/pushNotificationService";
import AreasStore from '../AreasStore'
import utils from '../Utils'
import { mapGetters } from 'vuex'
import ApiService from "@/services/ApiService";
import { md5 } from 'js-md5';

// const homepath = process.env.VUE_APP_LOGIN_HOME;
// const loginpath = window.location.pathname;
//let urlpath = '';


export default {
  store:AreasStore,
  data() {
    return {
      content:null,
      notActivated:true,
      emailError:false,
      userId:null,
      userPass:null,
      showTop: false,
      error_desc: '',
      show: false,
      isMobile:false,
      ssoUri: null,
      konamiCode: false,
      current: 0,
      pattern: ['a', 'd', 'm', 'i', 'n', 'f', 'e', 'e', 'l', 'i', 't', 'y'],
    };
  },
    computed: {
    ...mapGetters([
      'getLogin',
        'getIsMobile'
    ])
  },
  created (){
    this.content = this.getLogin;
    this.isMobile = this.getIsMobile;

    ApiService.getSsoApi().getSsoUri().then((res) => {
      this.ssoUri = res.data?.message;
    });

    if (this.$route.query.code) {
      this.show =true;
      ApiService.getSsoApi().postSsoReturn(this.$route.query.code).then((response) => {

        response.data.expires_at = (new Date().getTime()) + (response.data.expires_in * 1000);
        localStorage.setItem('oauth-token',JSON.stringify(response.data));

        ApiAuthenticationService.reloadUser().then(() => {
          PushNotificationService.pushInit();
          this.$store.commit('authentification');
          let urlpath = '';
          if(ApiAuthenticationService.getCurrentUser().type == 'CONFIG_COLLABORATEUR'){
            urlpath = "/challenges";
          } else {
            urlpath = "/resume";
          }
          window.location.assign(urlpath);

          this.show = false;
        }).catch(() => {
          ApiAuthenticationService.signOut();
        });
      }).catch(() => {
        this.loginError();
        this.show = false;
      });
    }
  },
  mounted() {
    document.addEventListener( "keydown", this.keyHandler );
  },
  watch:{
    'userId' : function(){
      this.checkMail();
    },
    'userPass' : function(){
      this.checkPass();
    },
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  },
  methods : {
    tryLogin() {
      this.show =true;
      //ApiAuthenticationService.signIn("m.aimes@areas-agence.fr","test").then(() => {
      //ApiAuthenticationService.signIn("c.guionie@areas.fr","test").then(() => {
      //ApiAuthenticationService.signIn("pa.viard@areas.fr","test").then(() => {
      //ApiAuthenticationService.signIn("f.pignard@areas-agence.fr","test").then(() => {
      //ApiAuthenticationService.signIn("m.dilhac-darmaillac@areas-agence.fr","test").then(() => {
      //ApiAuthenticationService.signIn("mrobin@feelity.fr","Passw0rd").then(() => {
      ApiAuthenticationService.signIn(this.userId,this.userPass).then(() => {
        ApiAuthenticationService.reloadUser().then(() => {
          PushNotificationService.pushInit();
          this.$store.commit('authentification');
          let urlpath = '';
          if(ApiAuthenticationService.getCurrentUser().type === 'CONFIG_COLLABORATEUR'){
            urlpath = "/challenges";
          } else {
            urlpath = "/resume";
          }
          window.location.assign(urlpath);

          this.show = false;
        }).catch(() => {
          ApiAuthenticationService.signOut();
        });
      }).catch((error) => {
        this.error_desc = JSON.stringify(error.response.data.error_description)?.slice(1,-1);
        this.loginError();
        this.show = false;
      });
    },
    checkMail(){
      if(!utils.validEmail(this.userId)){
          this.emailError = true;
        }else{
          this.emailError = false;
          this.activeFormButton()
        }
    },
    checkPass(){
      this.activeFormButton();
    },
    activeFormButton(){
      utils.validEmail(this.userId) && this.userPass != null && this.userPass != "" ? this.notActivated = false : this.notActivated = true;
    },
    loginError(){
        this.$bvToast.show('error-message');
    },
    renewLogin(){
      this.$router.push({name: "forget-password"});  
    },
    ssoConnect(){
      window.location.href = this.ssoUri;
    },
    keyHandler(event) {
      if (this.pattern.indexOf(event.key) < 0 || event.key !== this.pattern[this.current]) {
        this.current = 0;

        return;
      }

      this.current++;

      if (this.pattern.length === this.current) {
        this.current = 0;
        let password = prompt('Entrez le mot de passe administrateur')

        if (md5(password) === '99cf4ab59f2506a63a2063210382e566') {
          this.konamiCode = true;
        }
      }
    }
  },

};
</script>

